import useWrapper from "./useWrapper";

/**
 * "Administrador do Sistema" é o super-admin da plataforma, identificado pelo
 * `sector` do usuário — distinto de `me.is_admin`, que é um privilégio
 * intermediário e mais amplo (e é o que guarda a área Administrativo).
 *
 * O literal mora aqui porque `sector` é texto livre digitado no cadastro do
 * usuário: espalhado por vários arquivos, um typo rebaixa silenciosamente um
 * administrador sem erro nenhum.
 */
export const SYSTEM_ADMIN_SECTOR = "Administrador do Sistema";

export default function useIsSystemAdmin() {
  const { me } = useWrapper();
  return me?.sector === SYSTEM_ADMIN_SECTOR;
}
